import { Injectable, Directive, ElementRef, Host, Input, HostBinding, Component, ViewEncapsulation, ViewChild, ContentChild, TemplateRef, NgModule } from '@angular/core';
import { TourService, TourHotkeyListenerComponent, TourModule } from 'ngx-tour-core';
import { CommonModule } from '@angular/common';
import { PopperController, Placements, Triggers, PopperContent, NgxPopperModule } from 'ngx-popper';
import withinviewport from 'withinviewport';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'ngx-popper';
import * as ɵngcc2 from '@angular/common';

function TourStepTemplateComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function TourStepTemplateComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "p", 4);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 5);
    ɵngcc0.ɵɵelementStart(5, "button", 6);
    ɵngcc0.ɵɵlistener("click", function TourStepTemplateComponent_ng_template_2_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.tourService.prev(); });
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "button", 7);
    ɵngcc0.ɵɵlistener("click", function TourStepTemplateComponent_ng_template_2_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.tourService.next(); });
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "button", 8);
    ɵngcc0.ɵɵlistener("click", function TourStepTemplateComponent_ng_template_2_Template_button_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.tourService.end(); });
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const step_r3 = ctx.step;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(step_r3 == null ? null : step_r3.title);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(step_r3 == null ? null : step_r3.content);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r2.tourService.hasPrev(step_r3));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" \u00AB ", step_r3 == null ? null : step_r3.prevBtnTitle, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r2.tourService.hasNext(step_r3));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", step_r3 == null ? null : step_r3.nextBtnTitle, " \u00BB ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", step_r3 == null ? null : step_r3.endBtnTitle, " ");
} }
const _c0 = function (a0) { return { step: a0 }; };
class NgxpTourService extends TourService {
}
NgxpTourService.ɵfac = /*@__PURE__*/ function () { let ɵNgxpTourService_BaseFactory; return function NgxpTourService_Factory(t) { return (ɵNgxpTourService_BaseFactory || (ɵNgxpTourService_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(NgxpTourService)))(t || NgxpTourService); }; }();
NgxpTourService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NgxpTourService, factory: NgxpTourService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxpTourService, [{
        type: Injectable
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TourStepTemplateService {
}
TourStepTemplateService.ɵfac = function TourStepTemplateService_Factory(t) { return new (t || TourStepTemplateService)(); };
TourStepTemplateService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: TourStepTemplateService, factory: TourStepTemplateService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TourStepTemplateService, [{
        type: Injectable
    }], null, null); })();
if (false) {
    /** @type {?} */
    TourStepTemplateService.prototype.template;
    /** @type {?} */
    TourStepTemplateService.prototype.templateComponent;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TourAnchorNgxPopperPopoverDirective extends PopperController {
    // Overwrite parent ngOnInit to do nothing since the content property isn't set yet.
    /**
     * @return {?}
     */
    ngOnInit() { }
    // Call this to initialize the popover once the content has been set
    /**
     * @return {?}
     */
    initialize() {
        super.ngOnInit();
    }
}
TourAnchorNgxPopperPopoverDirective.ɵfac = /*@__PURE__*/ function () { let ɵTourAnchorNgxPopperPopoverDirective_BaseFactory; return function TourAnchorNgxPopperPopoverDirective_Factory(t) { return (ɵTourAnchorNgxPopperPopoverDirective_BaseFactory || (ɵTourAnchorNgxPopperPopoverDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TourAnchorNgxPopperPopoverDirective)))(t || TourAnchorNgxPopperPopoverDirective); }; }();
TourAnchorNgxPopperPopoverDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TourAnchorNgxPopperPopoverDirective, selectors: [["", "tourAnchor", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TourAnchorNgxPopperPopoverDirective, [{
        type: Directive,
        args: [{ selector: '[tourAnchor]' }]
    }], null, null); })();
class TourAnchorNgxPopperDirective {
    /**
     * @param {?} tourService
     * @param {?} tourStepTemplate
     * @param {?} element
     * @param {?} popoverDirective
     */
    constructor(tourService, tourStepTemplate, element, popoverDirective) {
        this.tourService = tourService;
        this.tourStepTemplate = tourStepTemplate;
        this.element = element;
        this.popoverDirective = popoverDirective;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.tourService.register(this.tourAnchor, this);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.tourService.unregister(this.tourAnchor);
    }
    /**
     * @param {?} step
     * @return {?}
     */
    showTourStep(step) {
        this.isActive = true;
        this.tourStepTemplate.templateComponent.step = step;
        step.prevBtnTitle = step.prevBtnTitle || 'Prev';
        step.nextBtnTitle = step.nextBtnTitle || 'Next';
        step.endBtnTitle = step.endBtnTitle || 'End';
        this.popoverDirective.content = this.tourStepTemplate.template;
        this.popoverDirective.targetElement = this.element.nativeElement;
        this.popoverDirective.placement = step.placement || Placements.Auto;
        this.popoverDirective.showTrigger = Triggers.NONE;
        if (step.popperSettings) {
            this.popoverDirective.boundariesElement = step.popperSettings.boundariesElement || undefined;
            this.popoverDirective.closeOnClickOutside = step.popperSettings.closeOnClickOutside || false;
            this.popoverDirective.disableAnimation = step.popperSettings.disableAnimation || false;
            this.popoverDirective.disabled = step.popperSettings.disabled || false;
            this.popoverDirective.disableStyle = step.popperSettings.disableStyle || false;
            this.popoverDirective.forceDetection = step.popperSettings.forceDetection || false;
            this.popoverDirective.hideOnClickOutside = step.popperSettings.hideOnClickOutside || false;
            this.popoverDirective.hideOnScroll = step.popperSettings.hideOnScroll || false;
            this.popoverDirective.hideTimeout = step.popperSettings.hideTimeout || 0;
            this.popoverDirective.positionFixed = step.popperSettings.positionFixed || false;
            this.popoverDirective.showDelay = step.popperSettings.showDelay || 0;
            this.popoverDirective.showOnStart = step.popperSettings.showOnStart || false;
            this.popoverDirective.showTrigger = step.popperSettings.showTrigger || Triggers.NONE;
            this.popoverDirective.timeoutAfterShow = step.popperSettings.timeoutAfterShow || 0;
            //TODO: Can these even get passed in via json?
            // this.popoverDirective.popperModifiers = step.popperSettings.popperModifiers || undefined;
            // this.popoverDirective.popperOnHidden = step.popperSettings.popperOnHidden || undefined;
            // this.popoverDirective.popperOnShown = step.popperSettings.popperOnShown || undefined;
        }
        this.popoverDirective.initialize();
        if (step.hasOwnProperty('popperSettings') && step.popperSettings.hasOwnProperty('showDelay')) {
            this.popoverDirective.scheduledShow();
        }
        else {
            this.popoverDirective.show();
        }
        if (!step.preventScrolling) {
            if (!withinviewport(this.element.nativeElement, { sides: 'bottom' })) {
                ((/** @type {?} */ (this.element.nativeElement))).scrollIntoView(false);
            }
            else if (!withinviewport(this.element.nativeElement, { sides: 'left top right' })) {
                ((/** @type {?} */ (this.element.nativeElement))).scrollIntoView(true);
            }
        }
    }
    /**
     * @return {?}
     */
    hideTourStep() {
        this.isActive = false;
        this.popoverDirective.hide();
    }
}
TourAnchorNgxPopperDirective.ɵfac = function TourAnchorNgxPopperDirective_Factory(t) { return new (t || TourAnchorNgxPopperDirective)(ɵngcc0.ɵɵdirectiveInject(NgxpTourService), ɵngcc0.ɵɵdirectiveInject(TourStepTemplateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(TourAnchorNgxPopperPopoverDirective, 1)); };
TourAnchorNgxPopperDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TourAnchorNgxPopperDirective, selectors: [["", "tourAnchor", ""]], hostVars: 2, hostBindings: function TourAnchorNgxPopperDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("touranchor--is-active", ctx.isActive);
    } }, inputs: { tourAnchor: "tourAnchor" } });
/** @nocollapse */
TourAnchorNgxPopperDirective.ctorParameters = () => [
    { type: NgxpTourService },
    { type: TourStepTemplateService },
    { type: ElementRef },
    { type: TourAnchorNgxPopperPopoverDirective, decorators: [{ type: Host }] }
];
TourAnchorNgxPopperDirective.propDecorators = {
    tourAnchor: [{ type: Input }],
    isActive: [{ type: HostBinding, args: ['class.touranchor--is-active',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TourAnchorNgxPopperDirective, [{
        type: Directive,
        args: [{
                selector: '[tourAnchor]'
            }]
    }], function () { return [{ type: NgxpTourService }, { type: TourStepTemplateService }, { type: ɵngcc0.ElementRef }, { type: TourAnchorNgxPopperPopoverDirective, decorators: [{
                type: Host
            }] }]; }, { isActive: [{
            type: HostBinding,
            args: ['class.touranchor--is-active']
        }], tourAnchor: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    TourAnchorNgxPopperDirective.prototype.tourAnchor;
    /** @type {?} */
    TourAnchorNgxPopperDirective.prototype.isActive;
    /**
     * @type {?}
     * @private
     */
    TourAnchorNgxPopperDirective.prototype.tourService;
    /**
     * @type {?}
     * @private
     */
    TourAnchorNgxPopperDirective.prototype.tourStepTemplate;
    /**
     * @type {?}
     * @private
     */
    TourAnchorNgxPopperDirective.prototype.element;
    /**
     * @type {?}
     * @private
     */
    TourAnchorNgxPopperDirective.prototype.popoverDirective;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TourStepTemplateComponent extends TourHotkeyListenerComponent {
    /**
     * @param {?} tourStepTemplateService
     * @param {?} tourService
     */
    constructor(tourStepTemplateService, tourService) {
        super(tourService);
        this.tourStepTemplateService = tourStepTemplateService;
        this.tourService = tourService;
        this.step = {};
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.tourStepTemplateService.templateComponent = this;
    }
    /**
     * @return {?}
     */
    ngAfterContentInit() {
        this.tourStepTemplateService.template = this.popperContent;
    }
}
TourStepTemplateComponent.ɵfac = function TourStepTemplateComponent_Factory(t) { return new (t || TourStepTemplateComponent)(ɵngcc0.ɵɵdirectiveInject(TourStepTemplateService), ɵngcc0.ɵɵdirectiveInject(NgxpTourService)); };
TourStepTemplateComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TourStepTemplateComponent, selectors: [["tour-step-template"]], contentQueries: function TourStepTemplateComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TemplateRef, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.stepTemplateContent = _t.first);
    } }, viewQuery: function TourStepTemplateComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(PopperContent, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.popperContent = _t.first);
    } }, inputs: { stepTemplate: "stepTemplate" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 4, consts: [[1, "popper-content"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["defaultTemplate", ""], [1, "ngxp-title"], [1, "ngxp-content"], [1, "tour-step-navigation"], [1, "ngxp-btn", "btn-prev", 3, "hidden", "click"], [1, "ngxp-btn", "btn-next", 3, "hidden", "click"], [1, "ngxp-btn", "btn-end", 3, "click"]], template: function TourStepTemplateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "popper-content", 0);
        ɵngcc0.ɵɵtemplate(1, TourStepTemplateComponent_ng_container_1_Template, 1, 0, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, TourStepTemplateComponent_ng_template_2_Template, 11, 7, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.stepTemplate || ctx.stepTemplateContent || _r1)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c0, ctx.step));
    } }, directives: [ɵngcc1.PopperContent, ɵngcc2.NgTemplateOutlet], encapsulation: 2 });
/** @nocollapse */
TourStepTemplateComponent.ctorParameters = () => [
    { type: TourStepTemplateService },
    { type: NgxpTourService }
];
TourStepTemplateComponent.propDecorators = {
    popperContent: [{ type: ViewChild, args: [PopperContent, { static: true },] }],
    stepTemplate: [{ type: Input }],
    stepTemplateContent: [{ type: ContentChild, args: [TemplateRef, { static: false },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TourStepTemplateComponent, [{
        type: Component,
        args: [{
                encapsulation: ViewEncapsulation.None,
                selector: 'tour-step-template',
                template: `
    <popper-content class="popper-content">
      <ng-container
        *ngTemplateOutlet="
          stepTemplate || stepTemplateContent || defaultTemplate;
          context: { step: step }
        "
      ></ng-container>
    </popper-content>

    <ng-template #defaultTemplate let-step="step">
      <p class="ngxp-title">{{ step?.title }}</p>
      <p class="ngxp-content">{{ step?.content }}</p>
      <div class="tour-step-navigation">
        <button
          [hidden]="!tourService.hasPrev(step)"
          class="ngxp-btn btn-prev"
          (click)="tourService.prev()"
        >
          « {{ step?.prevBtnTitle }}
        </button>
        <button
          [hidden]="!tourService.hasNext(step)"
          class="ngxp-btn btn-next"
          (click)="tourService.next()"
        >
          {{ step?.nextBtnTitle }} »
        </button>
        <button class="ngxp-btn btn-end" (click)="tourService.end()">
          {{ step?.endBtnTitle }}
        </button>
      </div>
    </ng-template>
  `
            }]
    }], function () { return [{ type: TourStepTemplateService }, { type: NgxpTourService }]; }, { popperContent: [{
            type: ViewChild,
            args: [PopperContent, { static: true }]
        }], stepTemplate: [{
            type: Input
        }], stepTemplateContent: [{
            type: ContentChild,
            args: [TemplateRef, { static: false }]
        }] }); })();
if (false) {
    /** @type {?} */
    TourStepTemplateComponent.prototype.popperContent;
    /** @type {?} */
    TourStepTemplateComponent.prototype.stepTemplate;
    /** @type {?} */
    TourStepTemplateComponent.prototype.stepTemplateContent;
    /** @type {?} */
    TourStepTemplateComponent.prototype.step;
    /**
     * @type {?}
     * @private
     */
    TourStepTemplateComponent.prototype.tourStepTemplateService;
    /** @type {?} */
    TourStepTemplateComponent.prototype.tourService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TourNgxPopperModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: TourNgxPopperModule,
            providers: [
                TourStepTemplateService,
                ...TourModule.forRoot().providers,
                NgxpTourService,
            ],
        };
    }
}
TourNgxPopperModule.ɵfac = function TourNgxPopperModule_Factory(t) { return new (t || TourNgxPopperModule)(); };
TourNgxPopperModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TourNgxPopperModule });
TourNgxPopperModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, NgxPopperModule.forRoot()]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TourNgxPopperModule, [{
        type: NgModule,
        args: [{
                declarations: [TourAnchorNgxPopperDirective, TourAnchorNgxPopperPopoverDirective, TourStepTemplateComponent],
                exports: [TourAnchorNgxPopperDirective, TourAnchorNgxPopperPopoverDirective, TourStepTemplateComponent],
                imports: [CommonModule, NgxPopperModule.forRoot()]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TourNgxPopperModule, { declarations: function () { return [TourAnchorNgxPopperDirective, TourAnchorNgxPopperPopoverDirective, TourStepTemplateComponent]; }, imports: function () { return [CommonModule, ɵngcc1.NgxPopperModule]; }, exports: function () { return [TourAnchorNgxPopperDirective, TourAnchorNgxPopperPopoverDirective, TourStepTemplateComponent]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { TourAnchorNgxPopperDirective, TourNgxPopperModule, NgxpTourService as TourService, TourStepTemplateComponent, NgxpTourService as ɵa, TourAnchorNgxPopperPopoverDirective as ɵb, TourStepTemplateService as ɵc };

//# sourceMappingURL=ngx-tour-ngx-popper.js.map